import { Customer, useRepositoryQuery } from '@mews-commander/data-access';

export const useGetAllCustomersQuery = (ids: string[]): Customer[] => {
    const { data } = useRepositoryQuery(
        'customers',
        'getAll',
        { customerIds: ids },
        {
            enabled: !!ids.length,
            select: (result) => result || [],
        }
    );

    return data ?? [];
};
